$(document).ready(function() {
  window.themeWishlist = localStorage.getItem('items') ? JSON.parse(localStorage.getItem('items')) : [];
  window.updateWishListButtons();  
  wishlistPage();
})

// Add and remove
$(document).on('click', '[data-icon-wishlist]', function(e) {
  e.preventDefault();

  const {themeWishlist} = window;

  let self = $(this),
    ProductHandle = self.data('product-handle'),
    idxArr = themeWishlist.indexOf(ProductHandle);

  if(!self.hasClass('wishlist-added')) {
    self.addClass('wishlist-added');
    themeWishlist.push(ProductHandle);
    localStorage.setItem('items', JSON.stringify(themeWishlist));
  } else {
    self.removeClass('wishlist-added');
    themeWishlist.splice(idxArr, 1);
    localStorage.setItem('items', JSON.stringify(themeWishlist));
    if ($('.page').hasClass('page-wishlist')) {
      self.closest('tr').remove();
    }
  };
  window.updateWishListButtons();
});

window.updateWishListButtons = function () {
  const {themeWishlist} = window;
  
  for (let i = 0; i < themeWishlist.length; i++) {
    const icon = $('[data-product-handle="'+ themeWishlist[i] +'"]');
    icon.addClass('wishlist-added');
  };
  
  window.document.querySelector('.block-wishlist span.count').innerHTML = themeWishlist.length;
};


function wishlistPage() {
  if ($('.page').hasClass('page-wishlist')) {
    const {themeWishlist} = window;
    if (!themeWishlist.length) {
      $('.wishlist_table').css({ display: "none" });
    } else {
      $('#wishlist-empty').css({ display: "none" });
      themeWishlist.forEach(function(item) {
        const wishListContainer = $('[data-wishlist-container]');
        jQuery.getJSON(`/products/${item}.js`, function(product) {
          let productHTML = ''

          productHTML += `<tr class="product-item" data-id="product-${product.id}">`;
          productHTML += '<th class="product-image-container product-image" style="max-width: 130px;">';
          productHTML += `<a href="${product.url}" class="grid-view-item__link image-ajax" data-collections-related="/collections/all?view=related">`;
          productHTML += `<img class="img-responsive s-img lazyautosizes lazyloaded" src="${product.featured_image}" alt="${product.featured_image.alt}">`;
          productHTML += '</a></th>';
          productHTML += `<th class="" style="max-width: 500px;"><h5><a class="product-title" href="${product.url}" title="${product.title}">${product.title}</a></h5></th>`;
          if (product.compare_at_price_min > 0 && product.compare_at_price_min !== product.price_min) {
            productHTML += `<th class="price"><span class="money ins">${product.price_min}</span><span class="money del">${product.compare_at_price_min}</span></th>`;
          }
          else {
            productHTML += `<th class="price"><span class="money">${product.price_min}</span></th>`;
          }
          productHTML += `<th class=""><a class="btn btn--secondary wishlist-added" tabindex="-1" data-icon-wishlist data-product-handle="${product.handle}">${window.themeSettings.locales.wishlist.remove}</a></th>`;
          productHTML += '<th class="">';
          if (product.available) {
            if (product.variants.length == 1) {
              productHTML += `<form action="/cart/add" method="post" class="variants" id="AddToCartForm-${product.id}" enctype="multipart/form-data">`;
              productHTML += `<input type="hidden" name="id" value="${product.variants[0].id}"/>`
              productHTML += `<a class="btn btn--primary" tabindex="-1" title="${product.title}">${window.themeSettings.locales.wishlist.add_cart}</button>`;
              productHTML += '</form></th>';
            } else if (product.variants.length > 1){
              productHTML += `<a class="btn" title="${product.title}" href="${product.url}">${window.themeSettings.locales.wishlist.select_options}</a></th>`;
            }
          } else {
            productHTML += `<button class="btn btn-unavailable" type="submit" disabled>${window.themeSettings.locales.wishlist.unavailable}</button></th>`;
          }
          productHTML += '</tr>';

          wishListContainer.append(productHTML);

          const shopCurrency = window.Shopify.currency.active;
          const {currentCurrency} = window.Currency;
          window.Currency.convertAll(shopCurrency, currentCurrency);
        });
      });
    }
  }
}
